import styled from 'styled-components';

export default styled.div`
  .main-content {
    padding: 2rem 1rem 2.5rem;

    h2 {
      font-size: 1.5625rem; /* 25px */
    }
  }

  .header-section {
    padding: 0 1.5625rem; /* 25px */
    h2 {
      font-size: 1.25rem; /* 20px */

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        font-size: 1.5625rem; /* 25px */
      }
    }
    
    p {
      margin-bottom: 0;
    }
  }

  .finance-section {
    padding: 1.25rem 1.5625rem; /* 20px 25px */

    @media (min-width: ${props => props.theme.breakpoints.tablet}) {
      padding-top: 1.5rem;
    }

    p {
      line-height: 1.375em;
    }

    h2,
    .type-h3 {
      font-size: 1.125rem; /* 18px */
      font-weight: 700;
      margin-top: 0;

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        font-size: 1.25rem; /* 20px */
      }
    }
  }

  .home-only-section {
    padding: 1.25rem 1.5625rem; /* 20px 25px */
    h2 {
      font-size: 1.25rem; /* 20px */
      margin-top: 0;

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        font-size: 1.5625rem; /* 25px */
      }
    }

    .type-h3 {
      font-size: 1.125rem; /* 18px */
      padding-left: 2.5rem;
      margin: 1rem 0; /* 16px 0 */

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        font-size: 1.25rem; /* 20px */
      }
    }
  }

  .highlights-section {
    padding: 1.5625rem 3.25rem 0.3125rem; /* 25px 52px 5px */

    h2 {
      font-family: ${props => props.theme.fonts.primary};
      font-size: 1.25rem; /* 20px */
      font-weight: 600;
      margin: auto;
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      padding: 4.6875rem 1.5625rem 0.875rem; /* 75px 25px 14px */
      h2 {
        font-size: 1.5rem; /* 24px */
      }
    }
  }

  // CTA
  .inner {
    .skewed-secondary {
      .secondary {
        align-items: center;
        text-align: center;

        @media (min-width: ${props => props.theme.breakpoints.desktop}) {
          align-items: stretch;
          text-align: left;
        }
      }
    }
  }
`;